(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    /*
   * UNCOLLARED CLUB
   *
   * Festive Necklace Logic:
   *
   * Normal Necklace:
   *   - Pet Name
   *   - Pet Breed
   *   - Additional Notes
   *
   * Festive + With Name:
   *   - Pet Name
   *   - Pet Breed
   *   - Additional Notes
   *
   * Festive + Without Name:
   *   - Pet Name HIDDEN
   *   - Pet Name DISABLED
   *   - Pet Breed
   *   - Additional Notes
   */

  (function () {

    if (window.__ucNameFieldInit) return;

    window.__ucNameFieldInit = true;


    /*
     * Main function.
     *
     * Looks at the current variant ID and checks it
     * against the JSON variant map generated above.
     */
    function syncNameField() {

      document
        .querySelectorAll(
          '[data-personalization-block][data-festive="true"]'
        )
        .forEach(function (block) {

          var field = block.querySelector('[data-name-field]');
          var input = field && field.querySelector('input');

          var mapEl = block.querySelector('[data-name-variants]');

          var form = block.closest('form');

          var idInput =
            form && form.querySelector('input[name="id"]');


          /*
           * If this isn't a festive necklace,
           * don't do anything.
           */
          if (
            !field ||
            !input ||
            !mapEl ||
            !idInput
          ) {
            return;
          }


          /*
           * Read the variant map.
           */
          var map = {};

          try {

            map = JSON.parse(
              mapEl.textContent
            );

          } catch (e) {

            return;

          }


          /*
           * Convert the variant ID to a string
           * so it always matches the JSON keys.
           */
          var variantId =
            String(idInput.value);


          /*
           * true  = With Name
           * false = Without Name
           */
          var showName =
            map[variantId] === true;


          /*
           * Show / hide Pet Name.
           */
          field.hidden = !showName;


          /*
           * Disable the field when hidden.
           *
           * Disabled fields are NOT submitted
           * with the Shopify cart form.
           */
          input.disabled = !showName;


          /*
           * Clear Pet Name when switching
           * to Without Name.
           *
           * This prevents an old name from being
           * accidentally submitted later.
           */
          if (!showName) {
            input.value = '';
          }

        });

    }


    /*
     * Run after Shopify's variant events.
     *
     * Different Shopify theme versions can use
     * slightly different event names, so we listen
     * to both.
     */
    [
      'variant:update',
      'variant:selected'
    ].forEach(function (eventName) {

      document.addEventListener(
        eventName,
        function () {

          /*
           * Give Shopify a moment to update
           * the hidden variant ID first.
           */
          setTimeout(
            syncNameField,
            50
          );

          setTimeout(
            syncNameField,
            200
          );

        }
      );

    });


    /*
     * Listen for changes to variant selectors.
     *
     * This catches standard Shopify option
     * dropdowns / radio buttons.
     */
    document.addEventListener(
      'change',
      function (event) {

        var target =
          event.target;


        if (
          target.matches(
            'select[name="id"], ' +
            'input[name="id"], ' +
            'select[name^="options"], ' +
            'input[name^="options"], ' +
            'input[type="radio"][name*="option"], ' +
            'select'
          )
        ) {

          setTimeout(
            syncNameField,
            50
          );

          setTimeout(
            syncNameField,
            200
          );

        }

      }
    );


    /*
     * Watch the hidden variant ID input.
     *
     * Shopify themes can update this input when
     * a customer selects a different variant.
     */
    var observer =
      new MutationObserver(
        function (mutations) {

          var shouldSync =
            false;


          for (
            var i = 0;
            i < mutations.length;
            i++
          ) {

            var target =
              mutations[i].target;


            if (
              target &&
              target.getAttribute &&
              target.getAttribute('name') === 'id'
            ) {

              shouldSync = true;

              break;

            }

          }


          if (shouldSync) {

            syncNameField();

          }

        }
      );


    observer.observe(
      document.body,
      {
        subtree: true,
        attributes: true,
        attributeFilter: ['value']
      }
    );


    /*
     * Initial check when the page loads.
     */
    if (
      document.readyState === 'loading'
    ) {

      document.addEventListener(
        'DOMContentLoaded',
        function () {

          syncNameField();

          setTimeout(
            syncNameField,
            200
          );

        }
      );

    } else {

      syncNameField();

      setTimeout(
        syncNameField,
        200
      );

    }


  })();
  } catch(e) { console.error(e); }
})();

})();
